module.exports = __webpack_public_path__ + "images/emoji/eight.e5328b10ebf454dde7f6.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/eight.png
// module id = eMFR
// module chunks = 1